import { render, staticRenderFns } from "./Qjsq.vue?vue&type=template&id=144997fd&scoped=true"
import script from "./Qjsq.vue?vue&type=script&lang=js"
export * from "./Qjsq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144997fd",
  null
  
)

export default component.exports